import { OptimizelyProvider } from '@optimizely/react-sdk';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom-v5';
import { v4 as uuidv4 } from 'uuid';
import SiteLoading from '@/src/components/Wrapper/SiteLoading';
import {
  NEW_WEB_SMART_BOOKING_URL,
  SMART_BOOKING_URL,
} from '@/src/constants/endpoints';
import { SMART_BOOKING_NEW_WEB_REDIRECT } from '@/src/constants/feature-flags';
import { optimizely, useDecision } from '@/src/utils/optimizely';

const Redirect = () => {
  const { search } = useLocation();
  const [decision, clientReady, didTimeout] = useDecision(
    SMART_BOOKING_NEW_WEB_REDIRECT,
  );
  const isDecided = Boolean(clientReady || didTimeout);

  useEffect(() => {
    if (!isDecided) return;
    const target = decision.enabled
      ? NEW_WEB_SMART_BOOKING_URL
      : SMART_BOOKING_URL;
    window.location.replace(`${target}${search}`);
  }, [isDecided, decision.enabled, search]);

  return <SiteLoading />;
};

// Web fallback for the /smart-booking app deep link (devices without the app).
// Public route, so no login hop: my.ovoenergy.com drops the query string on return,
// and campaign params must reach the booking journey. Nobody is logged in, so the
// flag is decided for an anonymous visitor rather than a customer.
export const SmartBookingRedirect = () => {
  const [visitorId] = useState(() => uuidv4());

  return (
    <OptimizelyProvider
      optimizely={optimizely}
      user={{ id: visitorId }}
      timeout={500}
    >
      <Redirect />
    </OptimizelyProvider>
  );
};
